import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 6.66331C7 5.08097 8.75049 4.12529 10.0815 4.98095L18.383 10.3176C19.6076 11.1049 19.6076 12.8951 18.383 13.6823L10.0815 19.019C8.75049 19.8747 7 18.919 7 17.3366V6.66331Z",
		fill: "#333333"
	})
});
export default SvgPlay;
